import DefaultValidation from '@/services/validations/DefaultValidation';
import Message from '@/models/Message';

export default class StatusComercialValidation extends DefaultValidation{

    constructor(msgs) {
        super(msgs);
    }

    validate(model, refs) {
        let validated = true;
        let sc = model;

        if (!sc.descricao) {
            refs.descricaoInput.focusedOut = true;
            validated = false;
        }

        if (!sc.dias && sc.tipo != 'QI' && sc.tipo != 'R') {
            refs.diasInput.focusedOut = true;
            validated = false;
        }

        if (!validated){
            this.showMessage(new Message('alert', 'msg-campos-obrigatorios', true));
        }
        
        return validated;
    }

}